<div>
  <!-- <loading *ngIf="isLoading"></loading> -->
  <div *ngIf="!isLoading" class="invoice-header-btn">
    <div *ngIf="!isLoading && model.status == 1">
      <button pButton [label]="'Send Invoice'" class="custom-button-compact" type="button"
        (click)="showSendModal = true" style="margin-left: 7px"></button>
    </div>
    <div>
      <button pButton [label]="'Save Changes'" class="custom-button-compact" type="button" [disabled]="!valid"
        (click)="save()" style="margin-left: 9px"></button>
    </div>
  </div>
  <div *ngIf="!isLoading">

    <!-- attachments -->
    <div class="row">
      <ng-container *ngIf="form?.get('editInfo')?.value == true">
        <div class="col-4 pb-3">
          <div class="cards">
            <div class="medium medium-text" style="padding: 10px" (click)="logForm()">Bill To</div>
            <div class="border-bottom"></div>
            <div class="cards-items">
              <table class="w-hundred">
                <th id="invoice-form-bill-to" class="th-display-none"></th>
                <tbody>
                  <tr>
                    <td class="w-fifty f-w-bold">Edit Billing Info</td>
                    <td class="w-fifty">
                      <simple-control [label]="'Edit Billing Info'" [form]="form" key="editInfo" type="boolean" [readonly]="isAllFieldsReadonly">
                      </simple-control>
                    </td>
                  </tr>
                  <tr>
                    <td class="w-fifty f-w-bold">{{metadata['billTo']}}</td>
                    <td class="w-fifty">
                      <simple-control [label]="metadata['billTo']" [form]="form" key="billTo" type="text"
                        [readonly]="form?.get('editInfo')?.value == false || isAllFieldsReadonly"></simple-control>
                    </td>
                  </tr>
                  <tr>
                    <td class="f-w-bold">{{metadata['billToName']}}</td>
                    <td>
                      <simple-control [label]="metadata['billToName']" [form]="form" key="billToName" type="text"
                        [readonly]="isAllFieldsReadonly">
                      </simple-control>
                    </td>
                  </tr>
                  <tr>
                    <td class="f-w-bold">{{metadata['billToLastName']}}</td>
                    <td>
                      <simple-control [label]="metadata['billToLastName']" [form]="form" key="billToLastName" type="text"
                        [readonly]="isAllFieldsReadonly">
                      </simple-control>
                    </td>
                  </tr>
                  <tr>
                    <td class="f-w-bold">{{metadata['billToAddress']}}</td>
                    <td>
                      <simple-control [label]="metadata['billToAddress']" [form]="form" key="billToAddress" type="text"
                        [readonly]="isAllFieldsReadonly">
                      </simple-control>
                    </td>
                  </tr>
                  <tr>
                    <td class="f-w-bold">{{metadata['billToCity']}}</td>
                    <td>
                      <simple-control [label]="metadata['billToCity']" [form]="form" key="billToCity" type="text"
                        [readonly]="isAllFieldsReadonly">
                      </simple-control>
                    </td>
                  </tr>
                  <tr>
                    <td class="f-w-bold">{{metadata['billToStateCode']}}</td>
                    <td>
                      <simple-control [label]="metadata['billToStateCode']" [form]="form" key="billToStateCode" type="lookup"
                        [items]="lookups.stateCodes" [readonly]="isAllFieldsReadonly"></simple-control>
                    </td>
                  </tr>
                  <tr>
                    <td class="f-w-bold">{{metadata['billToZip']}}</td>
                    <td>
                      <simple-control [label]="metadata['billToZip']" [form]="form" key="billToZip"
                        type="zip" [readonly]="isAllFieldsReadonly"></simple-control>
                    </td>
                  </tr>
                  <tr>
                    <td class="f-w-bold">{{metadata['billToPhone']}}</td>
                    <td>
                      <simple-control [label]="metadata['billToPhone']" [form]="form" key="billToPhone" type="phone"
                        [readonly]="isAllFieldsReadonly">
                      </simple-control>
                    </td>
                  </tr>
                  <tr>
                    <td class="f-w-bold">{{metadata['billToEmail']}}</td>
                    <td>
                      <simple-control [label]="metadata['billToEmail']" [form]="form" key="billToEmail" type="text"
                        [readonly]="isAllFieldsReadonly">
                      </simple-control>
                    </td>
                  </tr>
                  <tr>
                    <td class="f-w-bold">{{metadata['poNumber']}}</td>
                    <td>
                      <simple-control [label]="metadata['poNumber']" [form]="form" key="poNumber"
                        type="text" [readonly]="isAllFieldsReadonly"></simple-control>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </ng-container>
      <div class="col-4 pb-3">
        <div class="cards">
          <div class="medium medium-text" style="padding: 10px" (click)="logForm()">Payment to FSC</div>
          <div class="border-bottom"></div>
          <div class="cards-items">
            <table class="w-hundred">
              <th id="invoice-form-payment-to-fsc" class="th-display-none"></th>
              <tbody>
                <tr *ngIf="form?.get('editInfo')?.value == false">
                  <td class="w-fifty f-w-bold">Edit Billing Info</td>
                  <td class="w-fifty">
                    <simple-control [label]="'Edit Billing Info'" [form]="form" key="editInfo"
                      type="boolean" [readonly]="isAllFieldsReadonly"></simple-control>
                  </td>
                </tr>
                <tr>
                  <td class="w-fifty f-w-bold">{{metadata['billTo']}}</td>
                  <td class="w-fifty">
                    <simple-control [label]="metadata['billTo']" [form]="form" key="billTo" type="text"
                      [readonly]="true">
                    </simple-control>
                  </td>
                </tr>
                <tr>
                  <td class="f-w-bold">{{metadata['invoiceSentManually']}}</td>
                  <td>
                    <simple-control [label]="metadata['invoiceSentManually']" [form]="form" key="invoiceSentManually"
                      type="lookup" [items]="lookups.yesNoNull" [readonly]="isAllFieldsReadonly"></simple-control>
                  </td>
                </tr>
                <tr>
                  <td class="f-w-bold">{{metadata['invoiceSentDate']}}</td>
                  <td>
                    <simple-control [label]="metadata['invoiceSentDate']" [form]="form" key="invoiceSentDate"
                      type="date" [readonly]="isAllFieldsReadonly" [readonlyLabel]="isAllFieldsReadonly ? (form?.get('invoiceSentDate')?.value | date:'shortDate') || '-' : null"></simple-control>
                  </td>
                </tr>
                <tr>
                  <td class="f-w-bold">{{metadata['invoiceDueDate']}}</td>
                  <td>
                    <simple-control [label]="metadata['invoiceDueDate']" [form]="form" key="invoiceDueDate"
                      type="date" [readonly]="isAllFieldsReadonly" [readonlyLabel]="isAllFieldsReadonly ? (form?.get('invoiceDueDate')?.value | date:'shortDate') || '-' : null"></simple-control>
                  </td>
                </tr>
                <tr>
                  <td class="f-w-bold">{{metadata['invoicePaid']}}</td>
                  <td>
                    <simple-control [label]="metadata['invoicePaid']" [form]="form" key="invoicePaid" type="lookup"
                      [items]="lookups.fscpaidbycustomer" (onChange)="fscPaidByChange($event)" [readonly]="isAllFieldsReadonly"></simple-control>
                  </td>
                </tr>
                <tr>
                  <td class="f-w-bold">{{metadata['fscPaidBy']}}</td>
                  <td>
                    <simple-control [label]="metadata['fscPaidBy']" [form]="form" key="fscPaidBy" type="lookup"
                      [items]="lookups.paymentMethod" (onChange)="fscPaidByChange($event)"  [readonly]="form?.get('invoicePaid')?.value == 3 || form?.get('invoicePaid')?.value == 5 || isAllFieldsReadonly" [readonlyLabel]="!isAllFieldsReadonly && (form?.get('invoicePaid')?.value == 3 || form?.get('invoicePaid')?.value == 5) ? 'N/A' : null"></simple-control>
                  </td>
                </tr>
                <tr *ngIf="showfscPaidByOther">
                  <td class="f-w-bold">{{metadata['fscPaidByOther']}}</td>
                  <td>
                    <simple-control [label]="metadata['fscPaidByOther']" [form]="form" key="fscPaidByOther" type="text" 
                      [readonly]="isAllFieldsReadonly">
                    </simple-control>
                  </td>
                </tr>
                <tr *ngIf="showRemainder">
                  <td class="f-w-bold">{{metadata['partialAmountPaid']}}</td>
                  <td>
                    <simple-control [label]="metadata['partialAmountPaid']" [form]="form" key="partialAmountPaid"
                      type="currency" [readonly]="isAllFieldsReadonly"></simple-control>
                  </td>
                </tr>
                <tr *ngIf="showRemainder">
                  <td class="f-w-bold">{{metadata['remainderDue']}}</td>
                  <td>
                    <simple-control [label]="metadata['remainderDue']" [form]="form" key="remainderDue" type="currency"
                      [readonly]="true"></simple-control>
                  </td>
                </tr>
                <tr *ngIf="showWash">
                  <td class="f-w-bold">{{metadata['washedOn']}}</td>
                  <td>
                    <p-autoComplete dataKey="id" [(ngModel)]="washedOnItem" [required]="showWash" field="label"
                      inputStyleClass="simple-control" [style]="{ 'width': '100%' }" [suggestions]="washedOnItems"
                      [forceSelection]="true" appendTo="body" (completeMethod)="washedOnSearch($event)"
                      (onSelect)="washedOnSelect($event.value)" [readonly]="isAllFieldsReadonly"></p-autoComplete>
                      <div class="dynamic-error" *ngIf="!washedOnItem?.id">* Washed On is required</div>
                  </td>
                </tr>
                <tr>
                  <td class="f-w-bold">{{metadata['fscPaidDate']}}</td>
                  <td>
                    <simple-control [label]="metadata['fscPaidDate']" [form]="form" key="fscPaidDate" type="date"
                      [readonly]="form?.get('invoicePaid')?.value == 3 || form?.get('invoicePaid')?.value == 5 || isAllFieldsReadonly" [readonlyLabel]="!isAllFieldsReadonly && (form?.get('invoicePaid')?.value == 3 || form?.get('invoicePaid')?.value == 5) ? 'N/A' : null"></simple-control>
                  </td>
                </tr>
                <tr>
                  <td class="f-w-bold">{{metadata['sbi']}}</td>
                  <td>
                    <simple-control [label]="metadata['sbi']" [form]="form" key="sbi" type="text" [readonly]="isAllFieldsReadonly"></simple-control>
                  </td>
                </tr>
              </tbody>
            </table>
            <table class="detail-table billto-design">
              <th id="invoice-form-bill-to-design" class="th-display-none"></th>
              <tbody>
                <tr>
                  <td class="order-detail-font">{{model.detailMetadata['customerChargedTypeLabel']}} 
                    <dynamic-value class="table-data" [type]="'lookup'"
                      [value]="model.order?.customerChargedType" [items]="lookups.customerChargedType"></dynamic-value>
                  </td>
                  <td class="order-detail-font">
                    <span [style.background]="model.desiredProfit ? 'rgba(250, 250, 0, 0.7)' : null">{{model.detailMetadata['desiredProfit']}} </span>
                    <div class="table-data">
                      <dynamic-value [style.background]="model.desiredProfit ? 'rgba(250, 250, 0, 0.7)' : null" [type]="'text'" [value]="model.desiredProfit">
                      </dynamic-value>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td class="order-detail-font p-0 align-middle">{{model.detailMetadata['price']}}
                    <div class="table-data">
                      <dynamic-value [type]="'currency'" [value]="model.price"></dynamic-value>
                    </div>
                  </td>
                  <td class="order-detail-font p-0">{{model.formMetadata['companyProfit']}}
                    <div class="table-data">
                      <!-- <dynamic-value [type]="'currency'" [value]="model.companyProfit">
                      </dynamic-value> -->

                      <simple-control [label]="metadata['companyProfit']" [form]="form" key="companyProfit"
                      type="currency" [readonly]="true"></simple-control>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td class="order-detail-font">{{model.detailMetadata['orderDeposit']}}
                    <div class="table-data">
                      <dynamic-value [type]="'currency'" [value]="model.deposit">
                      </dynamic-value>
                    </div>
                  </td>
                  <td class="order-detail-font">{{model.formMetadata['poNumber']}}
                    <div class="table-data">
                      <dynamic-value [type]="'text'" [value]="model.poNumber">
                      </dynamic-value>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>{{model.detailMetadata['balanceDue']}}
                    <div class="table-data">
                      <dynamic-value [type]="'currency'" [value]="model.balanceDue">
                      </dynamic-value>
                    </div>
                  </td>
                  <td class="order-detail-font">{{model.detailMetadata['depositPaymentDate']}}
                    <div class="table-data">
                      <dynamic-value [type]="'date'" [value]="model.depositPaymentDate"></dynamic-value>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td class="order-detail-font">{{model.detailMetadata['brokerFee']}}
                    <div class="table-data">
                    <dynamic-value [type]="'currency'" [value]="model.order?.brokerFee"></dynamic-value>
                    </div>
                  </td>
                  <td class="order-detail-font">{{model.detailMetadata['depositBy']}}
                    <div class="table-data">
                      <dynamic-value [type]="'lookup'" [value]="model?.order?.depositBy" [items]="lookups.paymentMethodDepositBy">
                      </dynamic-value>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
            <div class="fsc-payment">
              <div class="order-detail-font order-from-pd">{{model.detailMetadata['paymentNotes']}}</div>
              <div class="order-detail-font order-detail-width">
                <simple-control [label]="model.detailMetadata['paymentNotes']" [form]="form" key="paymentNotes"
                  type="textarea" [readonly]="isAllFieldsReadonly" [ngClass]="{'readonly-field': isAllFieldsReadonly}"></simple-control>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-4 pb-3">
        <div class="cards">
          <div class="medium medium-text" style="padding: 10px">Carrier Payment</div>
          <div class="border-bottom"></div>
          <div class="cards-items">
            <table class="w-hundred">
              <th id="invoice-form-carrier-payment" class="th-display-none"></th>
              <tbody>
                <tr>
                  <td class="w-fifty f-w-bold">{{model.detailMetadata['carrierPaymentTypeLabel']}}</td>
                  <td style="padding: 4px;" class="w-fifty">
                    <dynamic-value [type]="'lookup'" [value]="model.order?.carrierPaymentType"
                                   [items]="lookups.viewcarrierpaymenttype"></dynamic-value>
                  </td>
                </tr>
                <tr>
                  <td class="w-fifty f-w-bold">{{metadata['priceToCarrier']}}</td>
                  <td class="w-fifty">
                    <simple-control [label]="metadata['priceToCarrier']" [form]="form" key="priceToCarrier"
                                    type="currency" [readonly]="true"></simple-control>
                  </td>
                </tr>
                <tr>
                  <td class="w-fifty f-w-bold">{{metadata['priceToCarrierAdjusted']}}</td>
                  <td class="w-fifty">
                    <simple-control [label]="metadata['priceToCarrierAdjusted']" [form]="form"
                                    key="priceToCarrierAdjusted" type="currency" [readonly]="true"></simple-control>
                  </td>
                </tr>
                <tr [style.background]="model?.additionalCost == 2 ? 'rgba(250, 250, 0, 0.7)' : null">
                  <td class="w-fifty f-w-bold">{{metadata['additionalCost']}}</td>
                  <td class="w-fifty">
                    <simple-control [label]="metadata['additionalCost']" [form]="form" key="additionalCost"
                                    type="lookup" [items]="lookups.yesNoOnly" [readonly]="true"></simple-control>
                  </td>
                </tr>
                <tr>
                  <td class="w-fifty f-w-bold">{{metadata['additionalCostAmount']}}</td>
                  <td class="w-fifty">
                    <div [ngClass]="isAllFieldsReadonly ? 'd-flex align-items-center pl-1' : 'currency-main'">
                      <span [ngClass]="isAllFieldsReadonly ? '' : 'adjust-to-profit-currency'">$</span>
                      <simple-control [class]="'adjust-to-profit'" [isPositiveNumberOnly]="true"
                                      [label]="metadata['additionalCostAmount']" [form]="form" key="additionalCostAmount"
                                      (onChange)="onChangeAdditionalCostAmount()" type="number" [readonly]="isAllFieldsReadonly">
                      </simple-control>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td class="w-fifty f-w-bold">{{metadata['wash']}}</td>
                  <td class="w-fifty">
                    <simple-control [label]="metadata['wash']" [form]="form" key="wash" (onChange)="onChangeAdditionalCostAmount()" type="currency" [readonly]="isAllFieldsReadonly"></simple-control>
                  </td>
                </tr>
                <tr>
                  <td class="w-fifty f-w-bold">
                    {{metadata['finalCarrierPayment']}}
                  </td>
                  <td class="w-fifty">
                    <simple-control [label]="metadata['finalCarrierPayment']" [form]="form" key="finalCarrierPayment"
                                    type="currency" [readonly]="true"></simple-control>
                  </td>
                </tr>
                <tr>
                  <td class="w-fifty f-w-bold">{{metadata['actualDeliveryDate']}}</td>
                  <td class="p-1">
                    <!-- <simple-control [label]="metadata['actualDeliveryDate']" [form]="form" key="actualDeliveryDate"
        type="date" [readonly]="true"></simple-control> -->
                    <dynamic-value [type]="'date'" [value]="model.actualDeliveryDate"></dynamic-value>
                  </td>
                </tr>
                <tr>
                  <td class="f-w-bold">{{metadata['paymentTermsLabel']}}</td>
                  <td *ngIf="!isPaymentTermsReadOnly" >
                    <simple-control [label]="metadata['paymentTermsLabel']" [model]="model" key="paymentTerms"
                                    [form]="form"  type="lookup" [readonly]="isAllFieldsReadonly"
                                    [items]="lookups.paymentTerms" ></simple-control>
                  </td>
                  <td *ngIf="isPaymentTermsReadOnly" style="padding: 4px;">
                    N/A
                  </td>
                </tr>
                <tr>
                  <td class="f-w-bold" [style.background]="model.carrierAchAccountName ? 'rgba(250, 250, 0, 0.7)' : null">{{metadata['achAccountName']}}</td>
                  <td [style.background]="model.carrierAchAccountName ? 'rgba(250, 250, 0, 0.7)' : null">
                    <simple-control [label]="metadata['achAccountName']" [model]="model" key="carrierAchAccountName"
                                    type="text" [readonly]="true"></simple-control>
                  </td>
                </tr>
                <tr>
                  <td class="w-fifty f-w-bold">
                    {{metadata['dateReceived']}}
                  </td>
                  <td class="w-fifty f-w-bold">
                    <simple-control [label]="metadata['dateReceived']" [form]="form" key="dateReceived" type="date"
                                    [maxDate]="today" [readonly]="isAllFieldsReadonly"></simple-control>
                  </td>
                </tr>

                <tr *ngIf="uploadRequired">
                  <td colspan="2">
                    <div class="medium medium-text" style="padding-top: 10px" (click)="logForm()">
                      Upload BOL/Invoice
                    </div>
                    <div style="border-bottom: 1px solid #B4B4B4; padding-top:10px; margin-bottom: 10px;"></div>
                    <table class="w-hundred">
                      <th id="invoice-form-upload-bol-invoice" class="th-display-none"></th>
                      <tbody>
                        <tr>
                          <uploads [orderId]="model?.order?.id" [orderGuid]="model?.order?.guid" (rowsChange)="changeUploadBol($event)" [showDelete]=""
                                   [addLabel]="'Upload BOL/Invoice'" [type]="1" [isDispatched]="isAllFieldsReadonly"></uploads>
                        </tr>
                      </tbody>
                      <div *ngIf="upload == null">
                        <div class="small-text italic upload-bol-invoice">
                          * Please upload BOL/Invoice
                        </div>
                      </div>
                    </table>
                  </td>
                </tr>

                <tr>
                  <td class="f-w-bold">{{metadata['carrierPaid']}}</td>
                  <td>
                    <simple-control [label]="metadata['carrierPaid']" [form]="form" key="carrierPaid" type="lookup"
                                    [items]="lookups.yesNoNullPaymentHold" (onChange)="onCarrierPaidChange()" [readonly]="isAllFieldsReadonly"></simple-control>
                  </td>
                </tr>
                <tr *ngIf="this.form?.get('dateReceived')?.value &&  (!updateDate || (updateDate && uploadRequired))">
                  <td class="f-w-bold">
                    <span [style.background]="model.carrierPaymentDateSystemCalculated ? 'rgba(250, 250, 0, 0.7)' : null">{{metadata['paymentScheduledDate']}}</span>
                  </td>
                  <td *ngIf="form?.get('paymentScheduledDate').value else nullValue">
                    {{form?.get('paymentScheduledDate').value}}
                  </td>
                  <ng-template #nullValue>
                    <span> - </span>
                  </ng-template>
                </tr>
                <tr>
                  <td class="f-w-bold" [ngClass]="form.get('carrierPaymentSpecialRequest').value ? 'yellow-bg' : null">{{metadata['carrierPaymentSpecialRequest']}}</td>
                  <td [ngClass]="form.get('carrierPaymentSpecialRequest').value ? 'yellow-bg' : null">
                    <simple-control [label]="metadata['carrierPaymentSpecialRequest']" [form]="form" key="carrierPaymentSpecialRequest" type="boolean" [readonly]="isAllFieldsReadonly">
                    </simple-control>
                  </td>
                </tr>
                <tr>
                  <td class="f-w-bold" [ngClass]="form.get('factoring').value ? 'yellow-bg' : null">{{metadata['factoring']}}</td>
                  <td [ngClass]="form.get('factoring').value ? 'yellow-bg' : null">
                    <simple-control [label]="metadata['factoring']" [form]="form" key="factoring" type="boolean" 
                      [readonly]="isAllFieldsReadonly">
                    </simple-control>
                  </td>
                </tr>
                <tr>
                  <td class="f-w-bold">{{metadata['carrierPaidDate']}}</td>
                  <td>
                    <simple-control [label]="metadata['carrierPaidDate']" [form]="form" key="carrierPaidDate"
                                    type="date" [required]="form?.get('carrierPaid')?.value == 2"
                                    [readonly]="form?.get('carrierPaid')?.value == 3 || form?.get('carrierPaid')?.value == null || isAllFieldsReadonly" [maxDate]="today"></simple-control>
                  </td>
                </tr>
                <tr>
                  <td class="f-w-bold">{{metadata['achNotes']}}</td>
                  <td>
                    <simple-control [label]="metadata['achNotes']" [form]="form" key="achNotes" type="text"
                                    [required]="form?.get('carrierPaid')?.value == 2"
                                    [readonly]="form?.get('carrierPaid')?.value == 3 || form?.get('carrierPaid')?.value == null || isAllFieldsReadonly">
                    </simple-control>
                  </td>
                </tr>

              </tbody>
            </table>
            <div class="payment-hold-key">
              <div class="payment-on-hold-key">{{metadata['paymentOnHoldReason']}}</div>
              <div colspan="2">
                <div class="order-notes-scrollbar detail-table">
                  <div class="payment-on-hold-reasons">
                    <notes-detail [entityName]="'invoice'" [entityId]="form?.get('id')?.value" [showAdd]="false" [notesOnly]="true" [reload]="reloadNotes" [isNewETANotes]="false">
                    </notes-detail>
                  </div>
                </div>
              </div>
            </div>
            <div *ngIf="!isLoading">
              <div class="row">
                <div class="col-12">
                  <div class="medium muted7 col-form-label-sm f-w-bold" >
                    {{metadata['accountingNotes']}}</div>
                  <simple-control [label]="metadata['accountingNotes']" [form]="form" key="accountingNotes"
                    type="textarea" class="carrier-payment-notes-width" [readonly]="isAllFieldsReadonly" [ngClass]="{'readonly-field': isAllFieldsReadonly}">
                  </simple-control>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-4 pb-3">
        <div class="cards">
          <div class="medium medium-text" style="padding: 10px">Commission</div>
          <div class="border-bottom"></div>
          <div class="cards-items">
            <table class="w-hundred">
              <th id="invoice-form-commission" class="th-display-none"></th>
              <tbody>
                <tr>
                  <td class="f-w-bold">
                    {{metadata['companyProfit']}}
                  </td>
                  <td class="w-fifty">
                    <simple-control [label]="metadata['companyProfit']" [form]="form" key="companyProfit"
                      type="currency" [readonly]="true"></simple-control>
                  </td>
                </tr>
                <tr>
                  <td class="w-fifty f-w-bold">
                    {{metadata['adjustmentToProfit']}}
                  </td>
                  <td>
                    <div [ngClass]="isAllFieldsReadonly ? 'd-flex align-items-center pl-1' : 'currency-main'">
                      <span [ngClass]="isAllFieldsReadonly ? '' : 'adjust-to-profit-currency'">$</span>
                        <simple-control [class]="'adjust-to-profit'" [label]="metadata['adjustmentToProfit']" [form]="form" key="adjustmentToProfit"
                        (onChange)="onChangeAdjustmentToprofit()" type="number" [readonly]="isAllFieldsReadonly">
                        </simple-control>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td class="w-fifty f-w-bold">
                    {{metadata['adjustmentProfit']}}
                  </td>
                  <td class="w-fifty">
                    <simple-control [class]="form.get('adjustmentToProfit').value || form.get('additionalCostAmount').value ? 'f-w-bold' : ''" [label]="metadata['adjustmentProfit']" [form]="form" key="adjustmentProfit"
                      type="currency" [readonly]="true"></simple-control>
                  </td>
                </tr>
                <tr *ngIf="isAdmin">
                  <td class="f-w-bold">
                    {{metadata['salesAgentCommissionPercentage']}}
                  </td>
                  <td>
                    <simple-control [label]="metadata['salesAgentCommissionPercentage']" [form]="form"
                      key="salesAgentCommissionPercentage" type="number"
                      [readonly]="model?.status >= 5 || isAllFieldsReadonly" [searchNumberOfVehicles]="true"></simple-control>
                  </td>
                </tr>
                <tr>
                  <td class="f-w-bold">
                    {{metadata['agentCommission']}}
                  </td>
                  <td>
                    <simple-control [label]="metadata['agentCommission']" [form]="form" key="agentCommission"
                      type="currency" [readonly]="true"></simple-control>
                  </td>
                </tr>
                <tr *ngIf="isAdmin">
                  <td class="f-w-bold">
                    {{metadata['salesAgentPaid']}}
                  </td>
                  <td>
                    <simple-control [label]="metadata['salesAgentPaid']" [form]="form" key="salesAgentPaid" type="lookup"
                    [items]="lookups.yesnonothingowed" [readonly]="isAllFieldsReadonly"></simple-control>
                    <!-- <simple-control [label]="metadata['salesAgentPaid']" [form]="form" key="salesAgentPaid"
                      type="boolean">
                    </simple-control> -->
                  </td>
                </tr>
                <tr>
                  <td class="f-w-bold">
                    {{metadata['agentPaidDate']}}
                  </td>
                  <td>
                    <simple-control [label]="metadata['agentPaidDate']" [form]="form" key="agentPaidDate" type="date"
                      [readonly]="form?.get('salesAgentPaid')?.value == 0 || isAllFieldsReadonly" [readonlyLabel]="!isAllFieldsReadonly && form?.get('salesAgentPaid')?.value == 0 ? '-' : null"></simple-control>
                  </td>
                </tr>
                <tr>
                  <td class="f-w-bold">
                    {{metadata['reviewCompletedDate']}}
                  </td>
                  <td>
                    <simple-control [label]="metadata['reviewCompletedDate']" [form]="form" key="reviewCompletedDate"
                      type="date" [readonly]="model?.reviewRequired != 2 || isAllFieldsReadonly" [readonlyLabel]="!isAllFieldsReadonly && model?.reviewRequired != 2 ? 'N/A' : null"></simple-control>
                  </td>
                </tr>
              </tbody>
            </table>

            <table class="w-hundred">
              <th id="invoice-form-mark-as-completed" class="th-display-none"></th>
              <tbody>
                <tr *ngIf="model?.complete && model?.completeMoveUpdatedUser">
                  <td class="w-fifty f-w-bold">
                    {{metadata['completeMoveUpdatedUser']}}
                  </td>
                  <td>
                    <simple-control [label]="metadata['completeMoveUpdatedUser']"
                    [form]="form" key="completeMoveUpdatedUser" type="text" [readonly]="true"></simple-control>
                  </td>
                </tr>
                <tr  *ngIf="model?.complete && model?.completeMoveUpdatedTimedate">
                  <td class="w-fifty f-w-bold">
                    {{metadata['completeMoveUpdatedTimedate']}}
                  </td>
                  <td>
                    <simple-control  [label]="metadata['completeMoveUpdatedTimedate']"
                    [form]="form" key="completeMoveUpdatedTimedate" type="datetime" [readonly]="true" ></simple-control>
                  </td>
                </tr>
              </tbody>
            </table>
            <div class="fsc-payment">
              <div class="order-detail-font">{{model.detailMetadata['commissionNotes']}}</div>
              <div class="order-detail-font order-detail-width">
                <simple-control class="carrier-payment-notes-width" [label]="model.detailMetadata['commissionNotes']" [form]="form" key="commissionNotes"
                  type="textarea" [readonly]="isAllFieldsReadonly" [ngClass]="{'readonly-field': isAllFieldsReadonly}"></simple-control>
              </div>
            </div>
            <table class="form-table">
              <th id="invoice-form-mark-as-completed" class="th-display-none"></th>
              <tbody>
                <tr>
                  <td class="width-sixtyfive">
                    <table class="w-hundred">
                      <tr>
                        <td class="f-w-bold text-align-start">
                          {{metadata['issueWithInvoices']}}
                        </td>
                        <td class="w-55" [ngClass]="{'order-from-pd text-align-start': model.order?.status === 6}">
                          <simple-control [label]="metadata['issueWithInvoices']" [class]="model.order?.status === 6 ? 'text-align-start' : 'text-align-start'" [form]="form"
                          key="issueWithInvoices" type="lookup" [items]="lookups.yesNo" [readonly]="model.order?.status === 6"></simple-control>
                        </td>
                      </tr>
                    </table>
                  </td>
                  <td>
                    <table class="w-hundred">
                      <tr>
                        <td class="f-w-bold">
                          {{metadata['complete']}}
                        </td>
                        <td>
                          <simple-control [class]="'mark-as-completed'" [label]="metadata['complete']" [form]="form" key="complete"
                            type="boolean" [ngClass]="{ 'disabled-mark-complete-checkbox': !model?.isReadyToAudit || (model?.isReadyToAudit && !this.isMarkComplete) || form?.get('issueWithInvoices')?.value === 2 || (!sharedService.getPermissions('completedmoves_uncheck_move_complete') && isAllFieldsReadonly) }"></simple-control>
                        </td>
                      </tr>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
            <div class="audit-issue-notes-section" style="margin-top: 15px;">
              <div class="order-detail-font" style="font-weight: bold; margin-bottom: 10px;">{{ metadata['auditIssueNotes']}}</div>
              <div class="order-detail-width">
                <simple-control class="audit-issue-notes-width audit-textarea-height" [label]="metadata['auditIssueNotes']" [form]="form" key="auditIssueNotes"
                  type="textarea" [readonly]="isAllFieldsReadonly" [ngClass]="{'readonly-field': isAllFieldsReadonly}"></simple-control>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-4 pb-3">
        <div class="cards">
          <div class="medium medium-text" style="padding: 10px">Bill To</div>
          <div class="border-bottom"></div>
          <div>
            <div class="cards-items">
              <!-- <button (click)="test()"></button> -->
              <table class="detail-table">
                <th id="invoice-form-bill-to-detail" class="th-display-none"></th>
                <tbody>
                  <ng-container>
                    <tr>
                      <td>{{model.detailMetadata['billTo']}}</td>
                      <td>
                        <dynamic-value [type]="'text'" [value]="model.billTo"></dynamic-value>
                      </td>
                    </tr>
                    <tr>
                      <td>{{model.detailMetadata['billToName']}}</td>
                      <td>
                        <dynamic-value [type]="'text'" [value]="model.billToName"></dynamic-value>
                      </td>
                    </tr>
                    <tr>
                      <td>{{model.detailMetadata['billToLastName']}}</td>
                      <td>
                        <dynamic-value [type]="'text'" [value]="model.billToLastName"></dynamic-value>
                      </td>
                    </tr>
                    <tr>
                      <td>{{model.detailMetadata['billToPhone']}}</td>
                      <td>
                        <dynamic-value [type]="'phone'" [value]="model.billToPhone"></dynamic-value>
                      </td>
                    </tr>
                    <tr>
                      <td>{{model.detailMetadata['billToEmail']}}</td>
                      <td>
                        <dynamic-value [type]="'text'" [value]="model.billToEmail"></dynamic-value>
                      </td>
                    </tr>
                    <tr>
                      <td>{{model.detailMetadata['billToAddress']}}</td>
                      <td>
                        <dynamic-value [type]="'text'" [value]="model.billToAddress" display="block"></dynamic-value>
                        <dynamic-value [type]="'text'" [value]="model.billToCity"></dynamic-value>, <dynamic-value
                          [type]="'text'" [value]="model.billToStateCode"></dynamic-value>&nbsp;<dynamic-value
                          [type]="'zip'" [value]="model.billToZip"></dynamic-value>
                      </td>
                    </tr>
                  </ng-container>
                  <!-- <ng-container *ngIf="model.billToCarrier == true">
                    <tr>
                      <td>{{model.detailMetadata['carrierName']}}</td>
                      <td>
                        <dynamic-value [type]="'text'" [value]="model.assignedCarrierName"></dynamic-value>
                      </td>
                    </tr>
                    <tr>
                      <td>{{model.detailMetadata['dispatcherName']}}</td>
                      <td>
                        <dynamic-value [type]="'text'" [value]="model.dispatcherName"></dynamic-value>
                      </td>
                    </tr>
                    <tr>
                      <td>{{model.detailMetadata['dispatcherPhone']}}</td>
                      <td>
                        <dynamic-value [type]="'phone'" [value]="model.dispatcherPhone"></dynamic-value>
                      </td>
                    </tr>
                    <tr>
                      <td>{{model.detailMetadata['dispatcherEmail']}}</td>
                      <td>
                        <dynamic-value [type]="'text'" [value]="model.dispatcherEmail"></dynamic-value>
                      </td>
                    </tr>
                    <tr>
                      <td>{{model.detailMetadata['poNumber']}}</td>
                      <td>
                        <dynamic-value [type]="'text'" [value]="model.poNumber"></dynamic-value>
                      </td>
                    </tr>
                  <ng-container *ngIf="!isNewRecordForTruckOverhual">
                    <tr>
                      <td>{{model.detailMetadata['driverName']}}</td>
                      <td>
                        <dynamic-value [type]="'text'" [value]="model.driverName"></dynamic-value>
                      </td>
                    </tr>
                    <tr>
                      <td>{{model.detailMetadata['driverPhone']}}</td>
                      <td>
                        <dynamic-value [type]="'phone'" [value]="model.driverPhone"></dynamic-value>
                      </td>
                    </tr>
                  </ng-container>
                  <ng-container *ngIf="isNewRecordForTruckOverhual">
                    <tr>
                      <td>Driver:</td>
                      <td *ngFor="let d of driverNames; let i = index" style="display:block;">
                        <div *ngIf="i < driverPhones.length">
                          <dynamic-value [type]="'text'" [value]="d"></dynamic-value>{{', '}}
                          <dynamic-value [type]="'text'" [value]="driverPhones[i]"></dynamic-value>
                        </div>
                      </td>
                    </tr>
                  </ng-container>
                  </ng-container>
                  </ng-container> -->
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <div class="col-4 pb-3">
        <div class="cards">
          <div class="medium medium-text" style="padding: 10px" (click)="logForm()">Carrier Info</div>
          <div class="border-bottom"></div>
          <div class="cards-items">
            <table class="w-hundred">
              <th id="invoice-form-carrier-info" class="th-display-none"></th>
              <tbody>
                <tr>
                  <td class="w-fifty f-w-bold">{{metadata['assignedCarrierName']}}</td>
                  <td class="w-fifty">
                    <simple-control [label]="metadata['assignedCarrierName']" [form]="form" key="assignedCarrierName"
                      type="text" [readonly]="true"></simple-control>
                  </td>
                </tr>
                <tr>
                  <td class="w-fifty f-w-bold">{{metadata['carrierAchOnFile']}}</td>
                  <td class="w-fifty">
                    <simple-control [label]="metadata['carrierAchOnFile']" [form]="form" key="carrierAchOnFile"
                      type="lookup" [items]="lookups.yesNoNull" [readonly]="true"></simple-control>
                  </td>
                </tr>
                <tr *ngIf="model?.carrierACHOnFile == 2">
                  <td class="w-fifty f-w-bold">{{metadata['carrierAchNumber']}}</td>
                  <td class="w-fifty">
                    <simple-control [label]="metadata['carrierAchNumber']" [form]="form" key="carrierAchNumber"
                      type="text" [readonly]="true"></simple-control>
                  </td>
                </tr>
                <tr>
                  <td class="w-fifty f-w-bold">{{metadata['carrierBusinessPhone']}}</td>
                  <td class="w-fifty">
                    <simple-control [form]="form" [label]="metadata['carrierBusinessPhone']" key="carrierBusinessPhone"
                      type="phone" [readonly]="true"></simple-control>
                  </td>
                </tr>
                <tr>
                  <td style="padding: 10px 0;" class="w-fifty f-w-bold">
                    {{metadata['carrierAdditionalPhones']}}
                  </td>
                  <td class="w-fifty f-w-bold">
                    <div *ngFor="let p of carrierAdditionalPhones">
                      <dynamic-value [type]="'phone'" [value]="p" [readonly]="true"></dynamic-value>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td class="w-fifty f-w-bold">{{metadata['carrierPhone']}}</td>
                  <td class="w-fifty">
                    <simple-control [label]="metadata['carrierPhone']" [form]="form" key="carrierPhone" type="phone"
                      [readonly]="true"></simple-control>
                  </td>
                </tr>
                <tr>
                  <td class="w-fifty f-w-bold">{{metadata['dispatcherName']}}</td>
                  <td class="w-fifty">
                    <simple-control [label]="metadata['dispatcherName']" [form]="form" key="dispatcherName" type="text"
                      [readonly]="true"></simple-control>
                  </td>
                </tr>
                <tr>
                  <td class="w-fifty f-w-bold">{{metadata['dispatcherEmail']}}</td>
                  <td class="w-fifty">
                    <simple-control [label]="metadata['dispatcherEmail']" [form]="form" key="dispatcherEmail"
                      type="text" [readonly]="true"></simple-control>
                  </td>
                </tr>

                <ng-container *ngIf="!isNewRecordForTruckOverhual">
                <tr>
                  <td class="w-fifty f-w-bold">{{metadata['driverName']}}</td>
                  <td class="w-fifty">
                    <simple-control [label]="metadata['driverName']" [form]="form" key="driverName" type="text"
                      [readonly]="true"></simple-control>
                  </td>
                </tr>
                <tr>
                  <td class="w-fifty f-w-bold">{{metadata['driverPhone']}}</td>
                  <td class="w-fifty">
                    <simple-control [label]="metadata['driverPhone']" [form]="form" key="driverPhone" type="phone"
                      [readonly]="true"></simple-control>
                  </td>
                </tr>
              </ng-container>
              <ng-container *ngIf="isNewRecordForTruckOverhual">
                <tr>
                  <td class="f-w-bold align-top pt-1">Driver</td>
                  <td  *ngFor="let d of driverNames; let i = index" style="display:block;">
                    <div *ngIf="i < driverPhones.length" class="default-spacing-padding">
                      <dynamic-value [type]="'text'" [value]="d"></dynamic-value>{{', '}}
                      <dynamic-value [type]="'text'" [value]="driverPhones[i]"></dynamic-value>
                    </div>
                  </td>
                </tr>
              </ng-container>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="col-4 pb-3">
        <div class="cards">
          <div class="medium medium-text" style="padding: 10px" (click)="logForm()">Documents</div>
          <div class="border-bottom"></div>
          <div class="cards-items">
            <table class="w-hundred">
              <th id="invoice-form-documents" class="th-display-none"></th>
              <tbody>
                <tr>
                  <uploads [orderId]="model?.order?.id" [orderGuid]="model?.order?.guid" (rowsChange)="changeUploads($event)"
                    [addLabel]="'Add Invoice Docs'" [type]="2" [isOrderDoc]="true" [isDispatched]="isAllFieldsReadonly"></uploads>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- <div *ngIf="!isLoading">
    <div *ngIf="showCompleteWarning">
      <div class="small-text italic" style="color:#b00; text-align: right; width: 100%; display: inline-block">
        <img src="alert.svg" /> Warning: Invoice is marked complete without
        {{completeWarningFields}}
      </div>
    </div>
  </div> -->
</div>

<p-dialog [(visible)]="showSendModal" [style]="{width: '25vw'}" [modal]="true" [showHeader]="false" [closable]="false"
  appendTo="body">
  <div class="modal-body-custom">
    <div class="regular-text muted6 bold">
      Select contacts
    </div>
    <p-multiSelect [style]="{ 'width': '100%' }" styleClass="simple-control" appendTo="body" [maxSelectedLabels]="500"
      [options]="model.availableContacts" [filter]="false" [(ngModel)]="selectedContacts" ngDefaultControl>
    </p-multiSelect>
  </div>
  <div class="ui-dialog ui-dialog-footer">
    <div class="modal-footer-custom">
      <div class="link-button d-inline-block">
        <a class="muted7" (click)="showSendModal = false">Cancel</a>
      </div>
      <div class="link-button float-right d-inline-block">
        <button class="link-button" type="button" (click)="send()">Send</button>
      </div>
    </div>
  </div>
</p-dialog>

<!-- <p-dialog [(visible)]="showDeleteWarning" [style]="{width: '25vw'}" [modal]="true" [showHeader]="false"  appendTo="body">
  <div class="modal-body-custom">
    <div class="regular-text muted6 bold">
      Are you sure you want to delete {{(upload == null ? 'this file?' : upload?.fileName)}}?
    </div>
  </div>
  <div class="ui-dialog ui-dialog-footer">
    <div class="modal-footer-custom">
      <div class="link-button d-inline-block">
        <a class="muted7" (click)="showDeleteWarning = false;">No</a>
      </div>
      <div class="link-button float-right d-inline-block">
        <button class="link-button" type="button" (click)="showDeleteWarning = false; deleteBol()">Yes</button>
      </div>
    </div>
  </div>
</p-dialog> -->

<p-dialog [(visible)]="showPaymentOnHoldReasonModal" [style]="{width: '25vw'}" [modal]="true" [showHeader]="false" [closable]="false"
  appendTo="body">
  <div class="modal-body-custom">
    <div class="regular-text muted6 bold" style="padding-bottom: 5px;">
      <span>Reason For Payment On Hold </span>
    </div>
    <p-multiSelect [style]="{ 'width': '100%'}" styleClass="simple-control" appendTo="body" [selectionLimit]="3" [maxSelectedLabels]="500"
      [options]="paymentOnHoldReasonList" [filter]="false" [(ngModel)]="selectedPaymentOnHoldReason" ngDefaultControl>
    </p-multiSelect>
  </div>
  <div class="ui-dialog ui-dialog-footer">
    <div class="modal-footer-custom">
      <div class="link-button d-inline-block">
        <a class="muted7" (click)="closePaymentReasonDialog()">Cancel</a>
      </div>
      <div class="link-button float-right d-inline-block">
        <button class="link-button" type="button" (click)="save('paymentOnHold')">Submit</button>
      </div>
    </div>
  </div>
</p-dialog>
